<template>
  <tr class="js-product-subrow">
    <td class="variation-sub-row__cart">
      <AddToCart
        :name="name"
        :sku="variation.sku"
        :permalink="variation.permalink"
        :id="variation.id"
        :minQuantity="getPackageMinQty()"
        :maxQuantity="getPackageMaxQty()"
        :soldIndividually="variation.sold_individually"
        :measurementUnit="getPackageUnit()"
        :buyingStep="getPackageStep()"
        :stockStatus="variation.stock_status"
        :isRentable="isRentable()"
        :packages="packages"
        :currentPackage="selectedPackage"
        @packageChanged="triggerPackageChanged"
        @quantityChanged="triggerQuantityChange"
      />
    </td>

    <td class="variation-sub-row__price">
      <Price
        :regularPrice="getCurrentPackagePrice(Number(variation.regular_price))"
        :salePrice="getCurrentPackagePrice(Number(variation.sale_price))"
      />
    </td>

    <td
      v-for="attributeTaxonomy in displayedAttributeTaxonomies"
      :key="`variation_attribute_${attributeTaxonomy}`"
      :data-column="attributeTaxonomy"
    >
      <div class="shop-table__line">
        {{ getAttributeValue(variation.meta_fields, attributeTaxonomy) | emptyDash }}
      </div>
    </td>

    <td class="variation-sub-row__other" v-if="showOtherInfo">
      <div class="shop-table__line">
        {{ variation.excerpt }}
      </div>
    </td>
  </tr>
</template>

<script>
import Price from '@/layouts/general-ui/Price.vue';
import AddToCart from '@/layouts/general-ui/AddToCart.vue';

export default {
  name: 'VariationSubRow',
  components: {
    Price,
    AddToCart
  },
  props: {
    variation: Object,
    showOtherInfo: Boolean,
    displayedAttributeTaxonomies: Array,
    showDiscountLabel: Boolean,
    hideSKU: Boolean,
    name: String
  },
  data() {
    let selectedPackage = this.getSelectedPackage();
    let isPackageless = ( ! selectedPackage || selectedPackage === 'PT');
    let packages = this.parsePackageField();
    let selectedPackageData = selectedPackage ? packages.find(e => e.package_type_id == selectedPackage) : undefined;

    return {
      packages: packages,
      selectedPackage: selectedPackage,
      isPackageless: isPackageless,
      selectedPackageData: selectedPackageData,
      currentQuantity: isPackageless ? this.getPackageMinQty() : 1,
      fixedLength: ws_vue_store.fixed_length,
      translations: {
        productSKU: ws_vue_store.translations.product_SKU,
      }
    };
  }, // data
  filters: {
    emptyDash(value) {
      if (!value) return '-';
      return value;
    },
  },
  computed: {
    gridColumnTemplate() {
      let columnRule = '38rem';
      let NrOfColumns = this.displayedAttributeTaxonomies.length;

      if (this.showDiscountLabel) {
        columnRule += ' 1fr';
      } else {
        columnRule += ' 1fr';
      }

      for (let i = NrOfColumns; i > 0; i--) {
        columnRule += ' 1fr';
      }

      return {
        'grid-template-columns': columnRule
      };
    },
  },
  methods: {
    parsePackageField() {
      if (this.variation.packages) {
        try {
          let data = JSON.parse(this.variation.packages);
          if (data.find) {
            return data; // Check if parsed data is array
          }
        } catch {}
      }
      return [];
    },
    getSelectedPackage() {
      let selectedPackages = this.$store.getters.getSelectedPackages;
      return selectedPackages[this.variation.id] ? selectedPackages[this.variation.id] : '';
    },
    getCurrentPackageData() {
      if (this.selectedPackage) {
        return this.packages.find(e => e.package_type_id == this.selectedPackage);
      }
      return undefined;
    },
    triggerPackageChanged() {
      this.selectedPackage = this.getSelectedPackage();
      this.isPackageless = ( ! this.selectedPackage || this.selectedPackage === 'PT');
      this.currentQuantity = this.isPackageless ? this.getPackageMinQty() : 1;
      this.selectedPackageData = this.getCurrentPackageData(),
      this.$forceUpdate();
    },
    triggerQuantityChange(qty) {
      this.currentQuantity = qty;
      this.$forceUpdate();
    },
    getCurrentPackagePrice(price) {
      return Number((price * this.currentQuantity).toFixed(this.fixedLength));
    },
    getAttributeValue: function(attributes, attributeTaxonomy){
      if(attributes == undefined || Object.keys(attributes).length === 0) return;
      if(attributeTaxonomy === 'package_sizes') return this.getPackageSizeColumn();

      if(attributeTaxonomy === this.translations.productSKU) return this.variation.sku;

      const foundKey = Object.keys(attributes).find(key => key == 'attribute_' + attributeTaxonomy);
      if(foundKey == undefined) return '';

      // Decode html entity codes
      let textArea = document.createElement('textarea');
      textArea.innerHTML = attributes[foundKey];

      return textArea.value;
    },
    getPackageSizeColumn() {
      if (this.packages.length > 1) {
        let quatities = [];
        for (const packageData of this.packages) {
          quatities.push(packageData['qnty_in_package']);
        }
        return quatities.join('/');
      }
      return '';
    },
    isRentable() {
      if (this.variation.is_rentable || this.$store.getters.getRentCategory === '1')
        return true;

      return false;
    },
    getPackageMinQty() {
      if (this.isPackageless || this.selectedPackageData === undefined) {
        return Number(this.variation.get_min_purchase_quantity);
      } else {
        return this.selectedPackageData.qnty_in_package;
      }
    },
    getPackageMaxQty() {
      return Number(this.variation.get_max_purchase_quantity);
    },
    getPackageUnit() {
      return this.variation.measurement_unit != undefined ? this.variation.measurement_unit : '';
    },
    getPackageStep() {
      if (this.isPackageless || this.selectedPackageData === undefined) {
        return this.variation.buying_step != undefined ? this.variation.buying_step : 1;
      } else {
        return this.selectedPackageData.qnty_in_package;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.variation-sub-row {
  display: grid;
  gap: 2rem;

  div {
    word-break: break-all;
  }
}
</style>
